const processEnv = typeof process !== 'undefined' ? process.env : {};
const injectedEnv = window && window.env ? window.env : {};
const env = {
    ...processEnv,
    ...injectedEnv,
};
export { env };
